import { RouterProvider } from 'react-router-dom'
import { Suspense, useEffect } from 'react'
import { AuthProvider } from './auth/AuthProvider'
import { routerConfig } from './router'
import { ErrorBoundary } from './components/ErrorBoundary'
import { Toaster } from './components/Toaster'
import { PomodoroProvider } from './contexts/PomodoroContext'
import { FloatingPomodoro } from './components/FloatingPomodoro'
import { applyTheme, type Theme } from './hooks/useTheme'

function ThemeInit() {
  useEffect(() => {
    const stored = localStorage.getItem('theme') as Theme | null
    applyTheme(stored === 'dark' ? 'dark' : 'light')
  }, [])
  return null
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeInit />
      <AuthProvider>
        <PomodoroProvider>
          <Suspense fallback={<div className="p-6">Loading…</div>}>
            <RouterProvider router={routerConfig} />
          </Suspense>
          <Toaster />
          <FloatingPomodoro />
        </PomodoroProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}